<!-- non-score popup -->
<div class="subcription-pop-wrap" *ngIf="examtype != 'SCHOLARSHIPTEST'">
    <a  (click)="close()" class="link UNFAPP-crossbtn-cont"><img src="assets/img/filter-close-icon.png" class="icon UNFAPP-crossbtn-img" /></a>
    <div class="pophdr-area">
        <h3 class="UNFAPP_trialheading">Your trial has expired!</h3>
            <img src="assets/img/time-trial-calculator.svg" alt="" class="UNFAPP-extire-timeimg"/>
    </div>

    <h4 class="UNFAPP-trialblueheading">A little something, just for you! </h4>
    <!--<p class="UNFAPP-mesagetext">{{message}}</p>-->
    <h5 class="UNFAPP-textoff" *ngIf="examtype"><span>FLAT 10% OFF</span> on upgrading to Pro Package</h5>
    <h5 class="UNFAPP-textoff" *ngIf="!examtype"><span>FLAT 10% OFF</span> on upgrading to any of our packages</h5>
    <div class="UNFAPP-coupenboxcont">
        <img src="assets/img/cuponcode-icon.svg" alt="" />
        <div class="UNFAPP-coupen-innertext">Coupon code: {{couponCode}}</div>
        <button class="UNFAPP-copybutton" (click) = "copyCoupon(couponCode)"><img src="assets/img/Copy-icon.svg" /><span class="UNFAPP-tooltip" *ngIf="showCoupon">Copied</span></button>
    </div>
    <div class="popactn-area">
        <button (click)="redirectSubscription()"class="btn UNFAPP-asmnt-blue-hdrbtn" *ngIf="examtype">Upgrade to Pro Package</button>
        <button (click)="redirectSubscription()"class="btn UNFAPP-asmnt-blue-hdrbtn" *ngIf="!examtype">Go to subscriptions</button>

    </div>
</div>

<!-- score popup -->
<div class="subcription-pop-wrap" *ngIf="examtype == 'SCHOLARSHIPTEST'">
    <a  (click)="activeModal.close()" class="link UNFAPP-crossbtn-cont"><img src="assets/img/filter-close-icon.png" class="icon UNFAPP-crossbtn-img" /></a>
    <div class="pophdr-area">        
        <h3 class="UNFAPP_trialheading">India’s no.1 Scholarship Test</h3>
            <img src="assets/img/expire-score.png" alt="" class="UNFAPP-extire-timeimg" />
    </div>
    
    <h4 class="UNFAPP-trialblueheading">A little something, just for you! </h4>
    <!--<p class="UNFAPP-mesagetext">{{message}}</p>-->
    <h5 class="UNFAPP-textoff"><span>FLAT 10% OFF</span> on Purchasing SCORE Package</h5>
    <div class="UNFAPP-coupenboxcont">
        <img src="assets/img/cuponcode-icon.svg" alt="" class="UNFAPP-gifticonimg" />
        <div class="UNFAPP-coupen-innertext">Coupon code: {{couponCode}}</div>
        <button class="UNFAPP-copybutton" (click) = "copyCoupon(couponCode)"><img src="assets/img/Copy-icon.svg" alt="" class="UNFAPP-copyicon" /><span class="UNFAPP-tooltip" *ngIf="showCoupon">Copied</span></button>
        <!-- <div class="row">
            <span>Copied</span>
        </div> -->
    </div>
    <div class="popactn-area">
        <button (click)="redirectSubscription()" class="btn UNFAPP-asmnt-blue-hdrbtn">REGISTER NOW</button>        
    </div>
</div>

<!--<div class="subcription-pop-wrap">
    <div class="pophdr-area">
        <img src="assets/img/cart-remove-red-icon.svg" alt="" />
        <h3>Subscription has expired!</h3>
    </div>
    <p>{{message}}</p>
    <div class="popactn-area">
        <button (click)="redirectSubscription()"class="popblue-btn">View Subscription Plans</button>
        <a  (click)="activeModal.close()" class="link">Cancel</a>
    </div>
</div>-->

